module.exports = __webpack_public_path__ + "img/symbol_10.f9f8a6bd.png";